let _initProto, _initClass, _init_name, _init_extra_name, _init_rules, _init_extra_rules, _init_defaultValue, _init_extra_defaultValue, _init_defaultValueData, _init_extra_defaultValueData, _init_disabled, _init_extra_disabled, _init_error, _init_extra_error, _init_invalid, _init_extra_invalid, _init_fieldProvider, _init_extra_fieldProvider, _init_formContextProvider, _init_extra_formContextProvider;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, customElement, onEvent, onUpdated, prop, registerSsrPreparationCallback } from "@ecopages/radiant";
import { consumeContext, onContextUpdate, provideContext } from "@ecopages/radiant/context";
import { findFieldControl, findFieldDescription, findFieldError, findFieldErrorElements, findFieldLabel, getAriaControlTargets, isNativeTextControl, readControlValue, RUI_FIELD_DEFAULT_VALUE_ATTR, RUI_FIELD_MANAGED_ATTR, writeControlValue, wireFieldControlName } from "../form/control-protocol";
import { formContext } from "../form/form-context";
import { fieldContext } from "./field-context";
function stripValidate(rules) {
  if (!rules) {
    return void 0;
  }
  const {
    validate: _validate,
    ...serializable
  } = rules;
  return serializable;
}
let _RuiField;
class RuiField extends RadiantElement {
  static {
    ({
      e: [_init_name, _init_extra_name, _init_rules, _init_extra_rules, _init_defaultValue, _init_extra_defaultValue, _init_defaultValueData, _init_extra_defaultValueData, _init_disabled, _init_extra_disabled, _init_error, _init_extra_error, _init_invalid, _init_extra_invalid, _init_fieldProvider, _init_extra_fieldProvider, _init_formContextProvider, _init_extra_formContextProvider, _initProto],
      c: [_RuiField, _initClass]
    } = _applyDecs(this, [customElement("rui-field")], [[prop({
      type: String,
      reflect: true,
      defaultValue: ""
    }), 0, "name"], [prop({
      type: Object
    }), 0, "rules"], [prop({
      type: Object
    }), 0, "defaultValue"], [prop({
      type: String,
      attribute: RUI_FIELD_DEFAULT_VALUE_ATTR
    }), 0, "defaultValueData"], [prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "disabled"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "error"], [prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "invalid"], [provideContext({
      context: fieldContext,
      initialValue: {
        name: "",
        controlId: "",
        descriptionId: "",
        errorId: "",
        error: void 0,
        invalid: false,
        required: false
      },
      hydrate: Object,
      serialize: value => ({
        ...value,
        rules: stripValidate(value.rules)
      })
    }), 0, "fieldProvider"], [consumeContext(formContext), 0, "formContextProvider"], [onContextUpdate({
      context: formContext,
      requestUpdate: false
    }), 2, "onFormContextChanged"], [onUpdated(["name"]), 2, "onNameUpdated"], [onUpdated(["rules", "defaultValue", "defaultValueData"]), 2, "onRulesUpdated"], [onUpdated(["disabled", "error", "invalid"]), 2, "onPresentationUpdated"], [onEvent({
      selector: "[data-rui-control], rui-combobox, rui-date-field, rui-date-range-picker, rui-select, rui-tag-group, rui-checkbox, rui-switch, rui-radio-group, rui-slider, rui-knob, rui-number-field, rui-listbox",
      type: "rui-change"
    }), 2, "onControlChange"], [onEvent({
      selector: "[data-rui-control]",
      type: "input",
      options: {
        capture: true
      }
    }), 2, "onControlInput"], [onEvent({
      selector: "[data-rui-control]",
      type: "change",
      options: {
        capture: true
      }
    }), 2, "onControlNativeChange"], [onEvent({
      selector: "[data-rui-control], rui-knob, rui-slider",
      type: "focusout"
    }), 2, "onControlFocusOut"]], 0, void 0, RadiantElement));
  }
  name = (_initProto(this), _init_name(this));
  rules = (_init_extra_name(this), _init_rules(this));
  defaultValue = (_init_extra_rules(this), _init_defaultValue(this));
  defaultValueData = (_init_extra_defaultValue(this), _init_defaultValueData(this));
  disabled = (_init_extra_defaultValueData(this), _init_disabled(this));
  error = (_init_extra_disabled(this), _init_error(this));
  invalid = (_init_extra_error(this), _init_invalid(this));
  fieldProvider = (_init_extra_invalid(this), _init_fieldProvider(this));
  formContextProvider = (_init_extra_fieldProvider(this), _init_formContextProvider(this));
  uid = (_init_extra_formContextProvider(this), Math.random().toString(36).slice(2, 9));
  /** Resolved field name from property or `name` attribute (Storybook can hydrate props after connect). */
  resolveFieldName() {
    return (this.name || this.getAttribute("name") || "").trim();
  }
  unregister;
  unregisterPresentation;
  registeredWithForm = false;
  /**
   * @remarks Registers SSR-prep rules on `fieldProvider` so hydrated fields recover them after a
   * real SSR round-trip (`prop:rules` does not survive that boundary; `connectedCallback` never
   * runs during SSR).
   */
  constructor() {
    super();
    registerSsrPreparationCallback(this, () => this.fieldProvider.setContext({
      rules: this.readFieldRules()
    }));
  }
  onConnected() {
    this.connectToForm();
  }
  disconnectedCallback() {
    this.unregister?.();
    this.unregister = void 0;
    this.unregisterPresentation?.();
    this.unregisterPresentation = void 0;
    this.registeredWithForm = false;
    super.disconnectedCallback();
  }
  get currentFormContext() {
    return this.formContextProvider?.getContext();
  }
  parseJsonAttr(raw) {
    if (!raw) {
      return void 0;
    }
    try {
      return JSON.parse(raw);
    } catch {
      return void 0;
    }
  }
  /**
   * Prefers the live `rules` prop — it's the only channel that can carry a `validate`
   * function. Falls back to `fieldProvider`'s own context, which only ever holds the
   * JSON-safe subset (see its `serialize` option) — this is what recovers rules after a
   * real SSR hydrate, since `prop:rules` itself doesn't survive that boundary.
   */
  readFieldRules() {
    const rules = this.rules;
    if (rules && typeof rules === "object" && !Array.isArray(rules) && Object.keys(rules).length > 0) {
      return rules;
    }
    return this.fieldProvider.getContext()?.rules;
  }
  readDefaultValue() {
    if (this.defaultValue !== void 0) {
      return this.defaultValue;
    }
    return this.parseJsonAttr(this.defaultValueData ?? this.getAttribute(RUI_FIELD_DEFAULT_VALUE_ATTR));
  }
  isRequired() {
    return Boolean(this.readFieldRules()?.required);
  }
  resolveErrorMessage(formCtx) {
    if (this.error) {
      return this.error;
    }
    const fieldName = this.resolveFieldName();
    if (!fieldName) {
      return void 0;
    }
    const ctx = formCtx ?? this.currentFormContext;
    return ctx?.fields[fieldName]?.error;
  }
  resolveInvalid(formCtx) {
    if (this.invalid) {
      return true;
    }
    if (this.error) {
      return true;
    }
    const fieldName = this.resolveFieldName();
    if (!fieldName) {
      return false;
    }
    const ctx = formCtx ?? this.currentFormContext;
    return ctx?.fields[fieldName]?.invalid ?? false;
  }
  connectToForm() {
    const fieldName = this.resolveFieldName();
    const ctx = this.currentFormContext;
    const actions = ctx?.actions;
    if (!ctx?.ready || !actions || !fieldName) {
      this.syncField();
      return;
    }
    if (!this.registeredWithForm) {
      this.registeredWithForm = true;
      this.unregisterPresentation?.();
      this.unregisterPresentation = actions.subscribePresentation(ctx2 => this.syncField(ctx2));
      this.unregister = actions.register({
        name: fieldName,
        rules: this.readFieldRules(),
        getRules: () => this.readFieldRules(),
        defaultValue: this.readDefaultValue(),
        getValue: () => {
          const control = findFieldControl(this);
          return control ? readControlValue(control) : void 0;
        },
        setValue: value => {
          const control = findFieldControl(this);
          if (control) {
            writeControlValue(control, value);
          }
        }
      });
      return;
    }
    actions.updateFieldOptions(fieldName, {
      rules: this.readFieldRules(),
      defaultValue: this.readDefaultValue()
    });
    this.syncField();
  }
  onFormContextChanged(ctx) {
    if (!this.registeredWithForm) {
      if (ctx.ready) {
        this.connectToForm();
      } else {
        this.syncField(ctx);
      }
      return;
    }
    this.syncField(ctx);
  }
  onNameUpdated() {
    this.unregister?.();
    this.unregister = void 0;
    this.unregisterPresentation?.();
    this.unregisterPresentation = void 0;
    this.registeredWithForm = false;
    this.connectToForm();
  }
  onRulesUpdated() {
    this.connectToForm();
  }
  onPresentationUpdated() {
    this.syncField();
  }
  onControlChange() {
    const fieldName = this.resolveFieldName();
    if (fieldName) {
      this.currentFormContext?.actions.handleFieldChange(fieldName);
    }
  }
  onControlInput() {
    const fieldName = this.resolveFieldName();
    if (fieldName) {
      this.currentFormContext?.actions.handleFieldChange(fieldName);
    }
  }
  onControlNativeChange() {
    const fieldName = this.resolveFieldName();
    if (fieldName) {
      this.currentFormContext?.actions.handleFieldChange(fieldName);
    }
  }
  onControlFocusOut() {
    const fieldName = this.resolveFieldName();
    if (fieldName) {
      this.currentFormContext?.actions.handleFieldBlur(fieldName);
    }
  }
  syncField(formCtx) {
    const controlHost = findFieldControl(this);
    const ariaTargets = controlHost ? getAriaControlTargets(controlHost) : [];
    const ariaTarget = ariaTargets[0] ?? null;
    const controlId = ariaTarget?.id || `rui-field-control-${this.uid}`;
    const descriptionId = `rui-field-desc-${this.uid}`;
    const errorId = `rui-field-error-${this.uid}`;
    const errorMessage = this.resolveErrorMessage(formCtx);
    const invalid = this.resolveInvalid(formCtx);
    const required = this.isRequired();
    const fieldName = this.resolveFieldName();
    wireFieldControlName(controlHost, ariaTarget, fieldName);
    const describedBy = [];
    const description = findFieldDescription(this);
    if (description) {
      description.id = descriptionId;
      describedBy.push(descriptionId);
    }
    const errorEl = findFieldError(this);
    if (errorEl) {
      errorEl.id = errorId;
      if (errorMessage) {
        describedBy.push(errorId);
      }
    }
    for (const [index, target] of ariaTargets.entries()) {
      if (!target.id) {
        target.id = index === 0 ? controlId : `${controlId}-${index}`;
      }
      target.setAttribute(RUI_FIELD_MANAGED_ATTR, "");
      target.setAttribute("aria-invalid", invalid ? "true" : "false");
      if (this.isRequired()) {
        target.setAttribute("aria-required", "true");
      } else {
        target.removeAttribute("aria-required");
      }
      if (describedBy.length > 0) {
        target.setAttribute("aria-describedby", describedBy.join(" "));
      } else {
        target.removeAttribute("aria-describedby");
      }
      if (this.disabled) {
        target.setAttribute("aria-disabled", "true");
        if (isNativeTextControl(target)) {
          target.disabled = true;
        }
      }
    }
    const label = findFieldLabel(this);
    if (label && ariaTarget) {
      label.htmlFor = ariaTarget.id;
    }
    for (const errorEl2 of findFieldErrorElements(this)) {
      errorEl2.textContent = errorMessage ?? "";
      if (errorMessage) {
        errorEl2.hidden = false;
        errorEl2.removeAttribute("hidden");
      } else {
        errorEl2.hidden = true;
      }
    }
    const nextFieldContext = {
      name: fieldName,
      controlId: ariaTarget?.id ?? controlId,
      descriptionId,
      errorId,
      error: errorMessage,
      invalid,
      required
    };
    const prev = this.fieldProvider.getContext();
    if (prev.name === nextFieldContext.name && prev.controlId === nextFieldContext.controlId && prev.descriptionId === nextFieldContext.descriptionId && prev.errorId === nextFieldContext.errorId && prev.error === nextFieldContext.error && prev.invalid === nextFieldContext.invalid && prev.required === nextFieldContext.required) {
      return;
    }
    this.fieldProvider.setContext(nextFieldContext);
  }
  static {
    _initClass();
  }
}
export { _RuiField as RuiField };